export function setCurrentTimeOnDates(dataArray: any[]): void {
  const currentTime = new Date();

  dataArray.forEach(item => {
    if (item.date instanceof Date) {
      item.date.setHours(
        currentTime.getHours(),
        currentTime.getMinutes(),
        currentTime.getSeconds()
      );
    }
  });
}
